import { PLATFORM_API_MODE } from "../env";

/**
 * The backend platform-operator realm (§9.1) is now real, and `realPlatformApiClient` is
 * the default (`env.ts`'s `PLATFORM_API_MODE`) — so the old blanket "DEMO MODE — backend
 * not yet implemented" banner would now be false on every screen it rendered on. This
 * component now reflects which client is actually wired up:
 *
 *   - Mock mode (`VITE_PLATFORM_API_MODE=mock`): the original loud, impossible-to-miss
 *     banner, reworded to describe an intentional local-dev opt-in rather than an
 *     unfinished backend.
 *   - Real mode (the default): no top-level banner at all — this app genuinely talks to a
 *     real backend now. What's STILL not backed by real data (centralized logs, plan/quota,
 *     onboarding-checklist tracking, storage usage) is called out per-section with the same
 *     small `MockBadge` pattern `SystemHealthPage` already established, not a second loud
 *     banner competing with the first.
 */
export function DemoModeBanner() {
  if (PLATFORM_API_MODE !== "mock") return null;

  return (
    <div className="demo-mode-banner" role="banner">
      <span className="demo-mode-banner__label">MOCK MODE</span>
      <span>
        <code>VITE_PLATFORM_API_MODE=mock</code> is set — every page here reads from an in-memory mock{" "}
        <code>PlatformApiClient</code>, not the real backend (the real platform-operator realm exists and is the
        default; this is an explicit local-dev opt-in). See{" "}
        <code>frontend/apps/platform-admin/ARCHITECTURE.md</code> for details.
      </span>
    </div>
  );
}
